import styled from "styled-components";
import { ids } from "@icarros/theme-react";
const { color, spacing } = ids;
export const RatingWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: ${spacing.ids_spacing_1x};
  .altcolor {
    path {
      fill: ${color.action.disabled.ids_color_action_disabled_base}!important;
    }
  }
`;
//# sourceMappingURL=Rating.style.js.map